import { api } from '../../api'
import calculateTotalAmountAgent from './calculateTotalAmountAgent'
import deleteExamForm from './deleteExamForm'
import getAllExamForms from './getAllExamForms'

import getAllExamFormsByAgent from './getAllExamFormsByAgent'

import getExamFormsByAgentFilter from './getExamFormsByAgentFilter'

import getDistricts from './getDistricts'
import getSubAgents from './getSubAgents'
import getTaluka from './getTaluka'
import saveExamForm from './saveExamForm'
import getSchoolsAgentWise from './getSchoolsAgentWise'
import getAllExamFormsByAgentAdminFilter from './getAllExamFormsByAgentAdminFilter'
import editExamForm from './editExamForm'
import getExamFormsForAdminFilter from './getExamFormsForAdminFilter'
import getAllExamFormsOfAgentsForAdminFilter from './getAllExamFormsOfAgentsForAdminFilter'
import saveCashDepositRecord from './saveCashDepositRecord'
import getCashDepositRecord from './getCashDepositRecord'
import deleteCashDepositRecord from './deleteCashDepositRecord'
import getAllExamSchools from './getAllExamSchools'
import createExamSchool from './createExamSchool'
import deleteExamSchool from './deleteExamSchool'
import getConsolidatedReport from './getConsolidatedReport'
import getAgentSchoolWiseReport from './getAgentSchoolWiseReport'
import softDeleteExamForm from './softDeleteExamForm'
import getDeletedExamForms from './getDeletedExamForms'

export const examApi = api.injectEndpoints({
    endpoints: build => ({
     
      GetAllExamFormsByAgents: getAllExamFormsByAgent(build),
      GetAllExamFormsByAgentsFilter: getExamFormsByAgentFilter(build),
      GetAllExamFormsByAgentsAdminFilter:getAllExamFormsByAgentAdminFilter(build),
      GetAllExamFormsForAdminFilter:getExamFormsForAdminFilter(build),
      GetAllExamFormsOfAgentsForAdminFilter:getAllExamFormsOfAgentsForAdminFilter(build), 
      GetAllExamSchools:getAllExamSchools(build),
      CreateExamSchool:createExamSchool(build),
      DeleteExamSchool:deleteExamSchool(build),
      GetConsolidatedReport:getConsolidatedReport(build),
      GetAgentSchoolWiseReport:getAgentSchoolWiseReport(build),
      SoftDeleteExamForm:softDeleteExamForm(build),
      GetDeletedExamForms:getDeletedExamForms(build),
       
      GetAllExamForms:getAllExamForms(build),
        GetSubAgentsByAgent:getSubAgents(build),
        GetDistrict:getDistricts(build),
        GetTalukaByDistrict:getTaluka(build),
        SaveExamForm:saveExamForm(build),
        EditExamForm:editExamForm(build),

        DeleteExamForm:deleteExamForm(build),
        GetTotalAmountAgent:calculateTotalAmountAgent(build),
        GetSchoolsAgentWise:getSchoolsAgentWise(build),

        SaveCashdepositRecord:saveCashDepositRecord(build),
        GetCashDepositRecords:getCashDepositRecord(build),
        DeleteCashDepositRecord:deleteCashDepositRecord(build),

       
    }),
    overrideExisting: true,
})

export const { 
    useGetAllExamFormsByAgentsQuery,
useGetAllExamFormsOfAgentsForAdminFilterMutation,
   useGetAllExamFormsByAgentsFilterMutation,
   useGetAllExamFormsForAdminFilterMutation,
   useGetAllExamFormsByAgentsAdminFilterMutation,

  // useGetAllExamSchoolsMutation,
  useGetAllExamSchoolsQuery,
   useCreateExamSchoolMutation,
   useDeleteExamSchoolMutation,

    useGetAllExamFormsQuery,
    useGetSubAgentsByAgentQuery,
    useGetDistrictQuery,
    useGetTalukaByDistrictMutation,
    useSaveExamFormMutation,
    useEditExamFormMutation,

    useDeleteExamFormMutation,
    useGetTotalAmountAgentQuery,
    useGetSchoolsAgentWiseQuery,
    useSaveCashdepositRecordMutation,
    useGetCashDepositRecordsQuery,
    useDeleteCashDepositRecordMutation,
    useGetConsolidatedReportMutation,
    useGetAgentSchoolWiseReportMutation,
    useSoftDeleteExamFormMutation,
    useGetDeletedExamFormsQuery,

 } = examApi

